var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4026 12.4031C13.0582 11.7474 13.5783 10.9691 13.9331 10.1125C14.2879 9.25586 14.4705 8.33775 14.4705 7.41056C14.4705 6.48337 14.2879 5.56525 13.9331 4.70864C13.5783 3.85202 13.0582 3.07368 12.4026 2.41806C11.7469 1.76243 10.9686 1.24236 10.112 0.887543C9.25538 0.532722 8.33726 0.350098 7.41007 0.350098C6.48288 0.350098 5.56476 0.532722 4.70815 0.887543C3.85153 1.24236 3.07319 1.76243 2.41757 2.41806C1.09348 3.74215 0.349609 5.53801 0.349609 7.41056C0.349609 9.28311 1.09348 11.079 2.41757 12.4031C3.74166 13.7272 5.53752 14.471 7.41007 14.471C9.28262 14.471 11.0785 13.7272 12.4026 12.4031ZM12.4026 12.4031L16.8496 16.8501",
    stroke: "#E6E6E6",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9a5caef813b24d1d034a10fdfca3e61e.svg";
export { ForwardRef as ReactComponent };